import './styles/global.css';
import 'vue-sonner/style.css';

import { createApp as createClientApp } from 'vue';
import { createHead } from '@unhead/vue/client';
import { createStore } from './stores';
import { createAppI18n } from './i18n';
import { createAppRouter } from './router';
import App from './app.vue';
import {
  languageInjectionKey,
  cookiesInjectionKey,
  i18nInjectionKey,
} from './utils/keys';
import lozad from './utils/lozad';

export interface AppInitParams {
  language: string;
  cookies: string;
}

export function createApp({ language, cookies }: AppInitParams) {
  const app = createClientApp(App);

  app.provide(languageInjectionKey, language);
  app.provide(cookiesInjectionKey, cookies);

  const i18n = createAppI18n(language);

  app.provide(i18nInjectionKey, i18n);
  app.use(i18n);

  const pinia = createStore();

  app.use(pinia);

  const router = createAppRouter({ pinia });

  app.use(router);

  return {
    app,
    router,
    pinia,
  };
}

const observer = lozad('.lozad', {
  enableAutoReload: true,
});

observer.observe();

const { app, router } = createApp({
  language: 'zh-CN',
  cookies: document.cookie,
});

const head = createHead();

app.use(head);

router.isReady().then(() => {
  app.mount('#app');
});
